import { useCallback, useEffect } from 'react';
import { postThemeToWidgetIframe } from 'Utils/widgetThemeSync';
import useUserTheme from './useUserTheme';

const useWidgetThemeSync = iframeRef => {
  const [theme] = useUserTheme();

  const pushTheme = useCallback(() => {
    postThemeToWidgetIframe(iframeRef?.current, theme);
  }, [iframeRef, theme]);

  useEffect(() => {
    pushTheme();
  }, [pushTheme]);

  return { theme, pushTheme };
};

export default useWidgetThemeSync;
